function Company() {
    return ( 
        <div>
            
        </div>
     );
}

export default Company;